import Router from "./../router";

const useMenuTree = () => {
  // Рекурсивно получить дерево страниц CMS
  const recursGetNavTitles = (arr, routeName) => {
    const { currentRoute } = Router;
    for (let item of arr) {
      const element = {
        title: item.title,
        to: { name: item.workplace }
      };
      if (item.children) {
        const elements = recursGetNavTitles(item.children, routeName);
        if (elements.length > 0) {
          return element.title !== null
            ? [element, ...elements]
            : [...elements];
        }
      } else if (
        item.workplace == (routeName || currentRoute.name) ||
        (item.workplace == currentRoute.meta.parentName &&
          currentRoute.meta.hiddenInToolbar &&
          !routeName)
      ) {
        return [element];
      }
    }
    return [];
  };

  return {
    recursGetNavTitles
  };
};

export { useMenuTree };
